import { Link } from 'react-router-dom'
import Logo from '../assets/logo.png'
// import { homePageUrl } from '../constants'

// old
{
  /* <a href={homePageUrl}>
  <img className='logo' src={Logo} alt='logo' />
</a> */
}

const PanenkaLogoLink = () => {
  return (
    <Link to='/'>
      <img className='logo' src={Logo} alt='logo' />
    </Link>
  )
}

export default PanenkaLogoLink
